import _get from 'lodash/get';
import { getBlockTemplateById, getSelectorTemplateById } from '../tornado/templates';
import { DISPLAY_SHOW_MORE_ON_GRIDS, SHOULD_DISPLAY_CONTEXT_TITLE } from './customer/default/abstractLayout.constants';

export const getBlockTemplateType = block =>
  getSelectorTemplateById(_get(block, 'alternativeContent.selectorTemplateId')) ||
  getBlockTemplateById(block.blockTemplateId);

export const calculateBlockHeight = layoutData => {
  const { blockType, data, itemSize, screenSize, displayShowMore, isSearchPage } = layoutData;
  const rowCounter = blockType.getRowCount;
  const getGap = blockType.getContentGap;
  const rowCount = rowCounter ? rowCounter({ content: data.content, displayShowMore, isSearchPage }, screenSize) : 1;
  const itemGap = getGap ? getGap(screenSize) : 0;

  const result = {
    h: (itemSize.h + itemGap) * rowCount,
    top: 0,
    bottom: 0,
    rowCount,
  };

  const handler = blockType.getOffsetsByBlockData;

  if (handler) {
    const { top, bottom, h } = handler(layoutData);
    result.top += top;
    result.bottom += bottom;
    result.h = (Number.isFinite(h) ? h : result.h) + top + bottom;
  }

  return result;
};

/**
 * Strips the layout response identifier a block id is prefixed with.
 *
 * The BFF hands out ids shaped `page_6aab185138b461.39708147--0f30812f-a8dc-45d4-bae7-b4644a227585`, where the
 * leading segment identifies the response rather than the block — so the same block arrives under a different id on
 * every request. Everything after the first `--` is the part that stays put, and that is what block views are matched
 * and the vertical focus anchored on. Ids without the prefix are returned untouched.
 *
 * NOTE: this is for identity comparisons only. The full id is what the BFF expects back for pagination, so
 * `block.id` itself must keep it.
 *
 * @param {string} id a block id
 * @returns {string} the part of the id that survives across responses
 */
export const getStableBlockId = id => {
  if (typeof id !== 'string') {
    return id;
  }

  const separator = id.indexOf('--');

  return separator === -1 ? id : id.slice(separator + 2);
};

/**
 * Builds the key a block view is matched on: a view can only be handed a block it is able to render, so both
 * template ids take part alongside the stable block identity
 *
 * @param {string} blockTemplateId block template identifier
 * @param {string} contentTemplateId content template identifier
 * @param {string} blockId a block id, prefixed or not
 * @returns {string} the matching key
 */
export const makeBlockViewKey = (blockTemplateId, contentTemplateId, blockId) =>
  `${blockTemplateId}|${contentTemplateId}|${getStableBlockId(blockId)}`;

export const shouldDisplayContextTitle = (entity, type) =>
  SHOULD_DISPLAY_CONTEXT_TITLE && _get(entity, 'type') === type;

export const shouldDisplayShowMoreButtons = entity =>
  DISPLAY_SHOW_MORE_ON_GRIDS && entity && (entity.type === 'program' || entity.type === 'season');

export const createLayoutAction = (entityType, entityId, analyticsKey) => ({
  item: {
    action: {
      target: {
        type: 'layout',
        value_layout: {
          type: entityType,
          id: entityId,
        },
      },
      analytics: {
        key: analyticsKey,
      },
    },
  },
});
